import { fetchWrapper } from '../helpers';

export const adminService = {
  getById,
  create
};

const baseUrl = `${process.env.BASE_URL}/api/vendor/admin`;

function getById(id) {
  return fetchWrapper.get(`${baseUrl}?id=${id}`);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}
